<template>
  <v-dialog :value="value" :retain-focus="false" persistent max-width="480" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>{{ $t("bookings.deposit_hold.extend") }}</v-card-title>
      <v-card-text>
        <v-text-field v-model="date" type="date" :label="$t('bookings.deposit_hold.retain_until')"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text :disabled="loading" @click="$emit('input', false)">{{ $t("custom.cancel") }}</v-btn>
        <v-btn color="primary" :loading="loading" :disabled="!date || loading" @click="$emit('submit', date)">
          {{ $t("bookings.deposit_hold.extend") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DepositExtendDialog",
  props: { value: Boolean, loading: Boolean, retainUntil: { type: String, default: null } },
  data() { return { date: this.retainUntil }; },
  watch: { value(open) { if (open) this.date = this.retainUntil; } },
};
</script>
